/* src/app/views/area-publica/home-page/card-vertente-info-public/card-vertente-info-public.component.scss */
#container-cards-vertentes {
  display: flex;
  align-content: space-between;
}
.card-vertente {
  width: 100%;
  height: 352px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1607843137);
  border-radius: 8px;
  display: flex;
  text-align: center;
  margin-left: 8px;
  margin-right: 8px;
  padding: 10px;
}
.card-vertente .icon {
  width: 90px;
  height: 90px;
  margin: auto;
}
.card-vertente .content {
  margin: auto;
}
@media only screen and (max-width: 1172px) {
  #container-cards-vertentes {
    flex-wrap: wrap;
  }
  #container-cards-vertentes .card-vertente {
    margin-bottom: 20px;
  }
}
/*# sourceMappingURL=card-vertente-info-public.component.css.map */
